import {
  DocumentData,
  onSnapshot,
  orderBy,
  query,
  QueryDocumentSnapshot,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useFirestore } from "./useFirestore.web";

export const usePhotos = (
  collectionId: "overviewPhotos" | "overviewMaps" | "signatureProofs",
  projectId: string,
  objectId: string
) => {
  const [tenantId, , , collection] = useFirestore();
  const [isLoading, setIsLoading] = useState(true);
  const [photos, setPhotos] = useState<QueryDocumentSnapshot<DocumentData>[]>(
    []
  );

  useEffect(() => {
    setIsLoading(true);

    const q = query(
      collection(
        ["projects", projectId, "objects", objectId, collectionId].join("/")
      ),
      orderBy("capturedAt")
    );

    const unsub = onSnapshot(q, (snapshot) => {
      setPhotos(snapshot.docs);

      setIsLoading(false);
    });

    return () => {
      unsub();
    };
  }, [tenantId, setIsLoading, setPhotos, projectId, objectId]);

  return [photos, isLoading] as const;
};
